import script from "./StatementConfirmCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementConfirmCard.vue?vue&type=script&setup=true&lang=js"

import "./StatementConfirmCard.vue?vue&type=style&index=0&id=0c97ba5e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c97ba5e"]])

export default __exports__